import type { HTMLAttributes, PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import type { WithSX } from '@elfsight/lib-utils';
import { applySX } from '@elfsight/lib-utils';
import { getLineHeight } from '@elfsight/widget-utils';

// TODO: Remove duplicated lineHeight in props and textStyle
type TextStyleWithLineHeight = TextStyleValue & { lineHeight: string | number };

export type TypographyProps = HTMLAttributes<HTMLDivElement> &
  PropsWithChildren<{
    textStyle?: Partial<TextStyleWithLineHeight>;
    color?: string;
    lineHeight?: number | string;
    display?: string;
  }>;

export const Typography = forwardRef<HTMLDivElement, TypographyProps>(
  function Typography(
    {
      textStyle = {},
      lineHeight,
      children,
      color = 'currentColor',
      display = 'block',
      ...forwardingProps
    },
    forwardingRef
  ) {
    const derivedLineHeight = getLineHeight({
      ...textStyle,
      lineHeight: lineHeight ?? textStyle.lineHeight
    });

    return (
      <Container
        $sx={{
          color,
          display,
          textTransform: textStyle.textTransform || 'inherit',
          textAlign: textStyle.textAlign || 'inherit',
          fontSize: textStyle.fontSize || 'inherit',
          fontStyle: textStyle.fontStyle || 'normal',
          fontWeight: textStyle.fontWeight || 'normal',
          lineHeight: derivedLineHeight,
          a: { color }
        }}
        {...forwardingProps}
        ref={forwardingRef}
      >
        {children}
      </Container>
    );
  }
);

const Container = styled.div<WithSX>`
  ${applySX};
`;
